import { useSession } from "@outschool/ui-auth";
import { Loading } from "@outschool/ui-legacy-component-library";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

import LoggedInHome from "./LoggedInHome";
import LoggedOutUserHome from "./LoggedOutUserHome";

export default function Home() {
  const { isLoggedIn, currentUserHasLoaded } = useSession();

  if (!currentUserHasLoaded) {
    return <Loading />;
  }

  return isLoggedIn ? <LoggedInHome /> : <LoggedOutUserHome />;
}
